import { faqItems } from '@/mocks/qieziData';
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              常见问题
            </h2>
            <p className="mt-3 text-sm text-foreground-500">关于茄子视频的常见疑问，都在这里</p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {item.question}
                  </span>
                  {openIndex === idx ? (
                    <i className="ri-arrow-up-s-line text-foreground-400 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line text-foreground-400 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                  )}
                </button>
                {openIndex === idx && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}